import React from 'react';
import { useTabController } from '../../Hooks/useTabController';
import ScheduleSaveStatus from '../../Tabs/Scheduling/ScheduleSaveStatus';
import LightingSaveStatus from '../../Tabs/Lights/LightingSaveStatus';

export default function SettingsSaveStatus() {
  const { controller, parent } = useTabController();
  return <>
    <ScheduleSaveStatus controller={controller} parent={parent} />
    <LightingSaveStatus controller={controller} />
  </>;
}
